export const tableHeader = [
  { name: "Account", space: 0, feildName: "accountName" },
  { name: "Request Type", space: 0, feildName: "requestType" },
  { name: "Request Date Range", space: 0, feildName: "requestDataRange" },
  { name: "Requested By", space: 0, feildName: "requestBy" },
  { name: "Requested At", space: 0, feildName: "requestedAt" },
  { name: "Completed At", space: 0, feildName: "completedAt" },
  { name: "Status", space: 0, feildName: "status" },
];

export const mobileRowHeader = [
  { name: "Worksite", keyName: "worksite", space: 1, feildName: "siteName" },
  {
    name: "Incident By",
    keyName: "incidentBy",
    space: 1,
    feildName: "fullName",
  },
  {
    name: "Asset Impacted",
    keyName: "assetImpacted",
    space: 1,
    feildName: "assetName",
  },
  {
    name: "Date, Time",
    keyName: "createdAt",
    space: 1,
    isDate: true,
    feildName: "impactRecordedAt",
  },
];

export const tableRowData = [
  {
    name: "Account",
    keyName: "accountName",
    space: 0,
    feildName: "companyName",
  },
  { name: "Worksite", keyName: "worksite", space: 0, feildName: "siteName" },
  {
    name: "Asset Type",
    keyName: "assetType",
    space: 0,
    feildName: "AssetTypeName",
  },
  {
    name: "Incident By",
    keyName: "incidentBy",
    space: 0,
    feildName: "fullName",
  },

  {
    name: "Asset Name",
    keyName: "assetImpacted",
    space: 0,
    feildName: "assetName",
  },
  {
    name: "Date, Time",
    keyName: "createdAt",
    space: 0,
    isDate: true,
    feildName: "impactRecordedAt",
  },
  {
    name: "Impact Severity",
    keyName: "impactSeverity",
    isStatus: true,
    space: 0,
    feildName: "impactSeverity",
    feildName2: "incidentObject",
  },
];

export const rowPerPageDropdown = [
  { name: 10, value: 10 },
  { name: 25, value: 25 },
  { name: 50, value: 50 },
  { name: 100, value: 100 },
];

export const filterByTypeData = [
  { name: "Asset", _id: "asset" },
  { name: "Asset Type", _id: "assetType" },
  { name: "User", _id: "inspectedBy" },
  { name: "Incident Type", _id: "incidentType" },
];

export const FilterByTypeLabelData = {
  asset: "Asset",
  assetType: "Asset Type",
  inspectedBy: "User",
  incidentType: "Incident Type",
};
